<template>
<div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
        <div class="col-sm-12 col-xs-12">
            <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
                <div class="col-sm-12 col-xs-12">
                    <div class="warranty-align">
                        <div class="warranty-header">
                            <h3>인증서 발행</h3>
                            <h5>인증서를 발행하고 교체 알림톡 전송 주기를 설정할 수 있습니다. <br/>환자에게 편리하게 인증서를 발행해보세요.</h5>
                        </div>
                        <div class="warranty-tab-container">
                            <a-tabs
                                animated
                                v-model:activeKey="step"
                                :tabBarStyle="{display: 'none', maxWidth: '1000px'}"
                            >
                                <a-tab-pane :key="1" tab="1">
                                    <div class="warranty-phone-container">
                                        <div class="warranty-cards">
                                            <div class="warranty-container">
                                                <div class="warranty-settings-title">환자 정보 입력</div>
                                                <a-form
                                                    ref="certificateFormRef"
                                                    name="custom-validation"
                                                    :model="certificateFormData"
                                                    :rules="certificateRules"
                                                >
                                                    <div class="warranty-settings-body">
                                                        <div class="col-sm-12 ant-input-div">
                                                            <a-form-item
                                                                :colon="false"
                                                                name="hospitalName"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                                :scroll-to-first-error="scrollToFirstRule"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="병원 검색"
                                                                        :is-required="true"
                                                                        :width="'120px'"
                                                                    />
                                                                </template>
                                                                <a-input 
                                                                    v-model:value="certificateFormData.hospitalName"
                                                                    :placeholder="'환자가 내원한 병원을 선택해 주세요.'"
                                                                    @click="openClientModal"
                                                                    readonly
                                                                >
                                                                </a-input>
                                                                <a-button 
                                                                    class="hospital-search-btn black no-radius-left"
                                                                    @click="openClientModal"
                                                                >
                                                                    병원 검색
                                                                </a-button>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="customerMobile"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="연락처"
                                                                        :is-required="true"
                                                                        :width="'120px'"
                                                                    />
                                                                </template>
                                                                <a-input 
                                                                    :maxlength="13"
                                                                    v-model:value="certificateFormData.customerMobile"
                                                                    :placeholder="'인증서를 발급받을 휴대폰 번호를 입력해 주세요.'"
                                                                    ref="mobileInput"
                                                                    @input="handleCustomerMobile"  
                                                                >
                                                                </a-input>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="customerName"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="이름"
                                                                        :is-required="true"
                                                                        :width="'120px'"
                                                                    />
                                                                </template>
                                                                <div
                                                                    style="display: flex; gap: 16px;"
                                                                >
                                                                    <a-input 
                                                                        v-model:value="certificateFormData.customerName"
                                                                        :placeholder="'환자명을 입력해 주세요.'"
                                                                    >
                                                                    </a-input>
                                                                </div>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="customerBirth"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="생년월일"
                                                                        :is-required="false"
                                                                        :width="'120px'"
                                                                    />
                                                                </template>
                                                                <div class="certificate-calendar-wrap">
                                                                    <a-date-picker
                                                                        type="date"
                                                                        class="contract-item"
                                                                        placeholder="생년월일"
                                                                        v-model:value="certificateFormData.customerBirth"
                                                                        :locale="locale"
                                                                        :bordered="false"
                                                                        @change="handleTemplateFormData('handleBirthday', $event)"
                                                                        :format="'YYYY/MM/DD'"
                                                                    />
                                                                </div>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="surgeryAt"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="교정 시작일"
                                                                        :is-required="true"
                                                                        :width="'120px'"
                                                                    />
                                                                </template>
                                                                <div class="certificate-calendar-wrap">
                                                                    <a-date-picker
                                                                        type="date"
                                                                        class="contract-item"
                                                                        placeholder="교정 시작일"
                                                                        v-model:value="certificateFormData.surgeryAt"
                                                                        :locale="locale"
                                                                        :bordered="false"
                                                                        @change="handleTemplateFormData('surgeryAt', $event)"
                                                                        :format="'YYYY/MM/DD'"
                                                                    />
                                                                </div>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="surgeryEndAt"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="교정 예상 종료일"
                                                                        :is-required="true"
                                                                        :width="'120px'"
                                                                    />
                                                                </template>
                                                                <div class="certificate-calendar-wrap">
                                                                    <a-date-picker
                                                                        type="date"
                                                                        class="contract-item"
                                                                        placeholder="교정 예상 종료일"
                                                                        v-model:value="certificateFormData.surgeryEndAt"
                                                                        :locale="locale"
                                                                        :bordered="false"
                                                                        @change="handleTemplateFormData('surgeryEndAt', $event)"
                                                                        :format="'YYYY/MM/DD'"
                                                                    />
                                                                </div>
                                                            </a-form-item>
                                                        </div>
                                                    </div>
                                                </a-form>
                                                <div class="warranty-bottom-container">
                                                    <div class="warranty-settings-title">
                                                        투명교정기 교체 알림 주기 설정
                                                        <div class="warranty-settings-desc">
                                                            알림톡은 오전 9시에 발송됩니다.
                                                        </div>
                                                    </div>
                                                    <a-form
                                                        ref="templateFormRef"
                                                        name="custom-validation"
                                                        :model="templateFormData"
                                                        :rules="templateRules"
                                                        :validate-status="'success'"
                                                    >
                                                        <div class="warranty-settings-body">
                            
                                                            <div class="col-sm-12 ant-input-div">
                                                                <a-form-item
                                                                    :colon="false"
                                                                    name="sendPeriod"
                                                                    :validate-status="'success'"
                                                                >
                                                                    <template #label>
                                                                        <form-label
                                                                            label-title="발송 주기"
                                                                            :is-required="true"
                                                                            :width="'120px'"
                                                                        />
                                                                    </template>
                                                                    <div class="col-sm-12 ant-input-div new-row"
                                                                        style="margin-top: -5px;"
                                                                    >
                                                                        <div class="period-setting">
                                                                            <div v-if="templateFormData.sendPeriod.type === readonly.sendPeriod.REGULAR" class="period-setting-container">
                                                                                <div class="period-setting-row">
                                                                                    <a-date-picker
                                                                                        type="date"
                                                                                        :locale="locale"
                                                                                        @change="handleTemplateFormData('startDate', $event)"
                                                                                        :format="'YYYY/MM/DD'"
                                                                                        style="width: 140px;"
                                                                                        v-model:value="templateFormData.sendPeriod.startDate"
                                                                                    />
                                                                                    기준으로
                                                                                </div>
                                                                                <a-form-item-rest>
                                                                                    <div class="period-setting-row" v-for="(item, index) in templateFormData.sendPeriod.deliveryDays" :key="index">
                                                                                        <div class="number-btn-container">
                                                                                            <a-input
                                                                                                v-model:value="item.afterDeliveryDay"
                                                                                                @keyup="handleNumberInInput($event, 'afterDeliveryDay', index)"
                                                                                                @change="formatNumber($event, 'afterDeliveryDay', index)"
                                                                                            />
                                                                                            <div class="plus-minus-button-wrap">
                                                                                                <a-button
                                                                                                    @click="handleNumberByClick('+', 'afterDeliveryDay', index)"
                                                                                                >
                                                                                                    +
                                                                                                </a-button>
                                                                                                <div class="separator-bar" />
                                                                                                <a-button
                                                                                                    @click="handleNumberByClick('-', 'afterDeliveryDay', index)"
                                                                                                >
                                                                                                    -
                                                                                                </a-button>
                                                                                                
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="period-setting-text">
                                                                                        일 간격으로
                                                                                        </div>
                                                                                        <div class="number-btn-container">
                                                                                            <a-input
                                                                                                v-model:value="templateFormData.sendPeriod.deliveryDays[index].afterDeliveryCount"
                                                                                                @keyup="handleNumberInInput($event, 'afterDeliveryCount', index)"
                                                                                                @change="formatNumber($event, 'afterDeliveryCount', index)"
                                                                                            />
                                                                                            <div class="plus-minus-button-wrap">
                                                                                                <a-button
                                                                                                    @click="handleNumberByClick('+', 'afterDeliveryCount', index)"
                                                                                                >
                                                                                                    +
                                                                                                </a-button>
                                                                                                <div class="separator-bar" />
                                                                                                <a-button
                                                                                                    @click="handleNumberByClick('-', 'afterDeliveryCount', index)"
                                                                                                >
                                                                                                    -
                                                                                                </a-button>
                                                                                                
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="period-setting-text">
                                                                                            회 발송
                                                                                        </div>
                                                                                        <button @click="deletePeriod(index)"
                                                                                            class="delete-period-btn"
                                                                                        >
                                                                                            <i class="fa-solid fa-x" />
                                                                                        </button>
    
                                                                                    </div>
                                                                                </a-form-item-rest>
                                                                                <div class="period-setting-row" style="width: 100%; display: flex; justify-content: center;">
                                                                                    <button @click="addPeriod"
                                                                                        class="add-period-btn"
                                                                                    >
                                                                                        <i class="fa-solid fa-plus" />알림 추가
                                                                                    </button>
                                                                                </div>
                                                                                <div 
                                                                                    class="period-setting-row" 
                                                                                    style="width: 100%; display: flex; justify-content: start;"
                                                                                    v-if="showFirstAlimtalkDate"    
                                                                                >
                                                                                    첫 알림톡은 {{ computedFirstAlimtalkDate }}에 발송됩니다.
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a-form-item>
                                                            </div>
                                                            <div class=warranty-settings-footer>
                                                                <a-button 
                                                                    type="primary"
                                                                    html-type="submit"
                                                                    @click="goToStep(2)"
                                                                >
                                                                    다음 단계로
                                                                </a-button>
                                                            </div>
                                                        </div>
                                                    </a-form>
                                                </div>
                                            </div>
                                        </div>
                                        <kakao-preview 
                                            :title="computedTemplateTitle"
                                            :content="computedTemplateContent"
                                        />
                                    </div>
                                </a-tab-pane>
                                <a-tab-pane :key="2" tab="2">
                                    <div class="warranty-phone-container">
                                        <div class="warranty-cards">
                                            <div class="warranty-container">
                                                <div class="warranty-settings-title">치료 후 주의사항 입력</div>
                                                <a-form
                                                    ref="certificateFormRef2"
                                                    name="custom-validation"
                                                    :model="certificateFormData"
                                                    :rules="certificateRules"
                                                >
                                                    <div class="warranty-settings-body">
                                                        <div class="col-sm-12 ant-input-div">
                                                            <a-form-item
                                                                :colon="false"
                                                                name="afterSurgeryText"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="치료 후 주의사항"
                                                                        :is-required="false"
                                                                    />
                                                                </template>
                                                                <a-textarea 
                                                                    v-model:value="templateFormData.afterSurgeryText"
                                                                    :placeholder="'치료 후 주의사항을 입력해 주세요.'"
                                                                    :style="'min-height: 360px;'"
                                                                ></a-textarea>
                                                            </a-form-item>

                                                            <a-form-item
                                                                :colon="false"
                                                                name="customerMobile"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="연락처"
                                                                        :is-required="true"
                                                                    />
                                                                </template>
                                                                <a-input 
                                                                    :maxlength="13"
                                                                    v-model:value="certificateFormData.customerMobile"
                                                                    :placeholder="'인증서를 발급받을 휴대폰 번호를 입력해 주세요.'"
                                                                    ref="mobileInput"
                                                                    @input="handleCustomerMobile"  
                                                                >
                                                                </a-input>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="customerName"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="이름"
                                                                        :is-required="true"
                                                                    />
                                                                </template>
                                                                <div
                                                                    style="display: flex; gap: 16px;"
                                                                >
                                                                    <a-input 
                                                                        v-model:value="certificateFormData.customerName"
                                                                        :placeholder="'환자명을 입력해 주세요.'"
                                                                    >
                                                                    </a-input>
                                                                </div>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="customerBirth"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="생년월일"
                                                                        :is-required="false"
                                                                    />
                                                                </template>
                                                                <div class="certificate-calendar-wrap">
                                                                    <a-date-picker
                                                                        type="date"
                                                                        class="contract-item"
                                                                        placeholder="생년월일"
                                                                        v-model:value="certificateFormData.customerBirth"
                                                                        :locale="locale"
                                                                        :bordered="false"
                                                                        @change="handleTemplateFormData('handleBirthday', $event)"
                                                                        :format="'YYYY/MM/DD'"
                                                                    />
                                                                </div>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="surgeryAt"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="교정 시작일"
                                                                        :is-required="true"
                                                                    />
                                                                </template>
                                                                <div class="certificate-calendar-wrap">
                                                                    <a-date-picker
                                                                        type="date"
                                                                        class="contract-item"
                                                                        placeholder="수술일자"
                                                                        v-model:value="certificateFormData.surgeryAt"
                                                                        :locale="locale"
                                                                        :bordered="false"
                                                                        @change="handleTemplateFormData('surgeryAt', $event)"
                                                                        :format="'YYYY/MM/DD'"
                                                                    />
                                                                </div>
                                                            </a-form-item>
                                                            <a-form-item
                                                                :colon="false"
                                                                name="surgeryEndAt"
                                                                class="hospital-search-row"
                                                                :validate-status="'success'"
                                                            >
                                                                <template #label>
                                                                    <form-label
                                                                        label-title="교정 예상 종료일"
                                                                        :is-required="true"
                                                                    />
                                                                </template>
                                                                <div class="certificate-calendar-wrap">
                                                                    <a-date-picker
                                                                        type="date"
                                                                        class="contract-item"
                                                                        placeholder="수술일자"
                                                                        v-model:value="certificateFormData.surgeryEndAt"
                                                                        :locale="locale"
                                                                        :bordered="false"
                                                                        @change="handleTemplateFormData('surgeryEndAt', $event)"
                                                                        :format="'YYYY/MM/DD'"
                                                                    />
                                                                </div>
                                                            </a-form-item>
                                                        </div>
                                                        <div class=warranty-settings-footer>
                                                            <button 
                                                                class="certi-gray-btn btn-hover"
        
                                                                @click="goToStep(1)"
                                                            >이전 단계로</button>
                                                            <a-button 
                                                                type="primary"
                                                                html-type="submit"
                                                                @click="submitCertificateData"
                                                                >
                                                                인증서 발행
                                                            </a-button>
                                                        </div>
                                                    </div>
                                                </a-form>
                                            </div>
                                        </div>
                                        <kakao-preview 
                                            :title="computedTemplateTitle"
                                            :content="computedTemplateContent"
                                        />
                                    </div>
                                </a-tab-pane>
                            </a-tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<search-client-modal
        :show-modal="modals.searchClientModal.show"
        @close-modal="modalHandler"
        @complete-search="receiveInfoFromClientModal"
/>
<confirm-modal
    @issue-certificate="issueCertificate"
    :showModal="modals.confirmModal.show"
    @close-modal="modalHandler"
/>
</template>
<script>
import { getAccessToken, getProfile } from '@/utils/tokenStore';
import { 
    deepCopy,
    phoneNumberFormatter,
    oneBtnDialog,
    twoBtnDialog,
    oneBtnHtmlDialog,
    jwtDecoder
    } from '@/utils/utils';
import ItemRequest from '@/apis/items';
import KakaoPreview from '@/views/CertificateSettings/component/KakaoPreview';
import SearchClientModal from '@/views/CertificateSettings/component/SearchClientModal';
import FormLabel from "@/views/components/FormLabel.vue";
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from "dayjs";
import 'dayjs/locale/ko';
import issueCertificateCommonApis from '@/views/CertificateSettings/api.js';
import ConfirmModal from '@/views/CertificateSettings/component/ConfirmModal';
import {
    MedicalDept,
    convertMedicalDept,
    ProductTypeEnum,
    KlipCompanyNameEnum,
    InformTextEnum,
    TraitTypeEnum,
    IssuanceMethodEnum,
} from '@/utils/enums';
import { RouterEnum } from '@/enums/router.enums';

const qrcodeUrl = require('@/assets/img/miniapp-qrcode.png');

import { Constants } from '@/utils/constants.js';

const readonly = {
    sendPeriod: {
    SINGLE: 'ONE',
    REGULAR: 'REGULAR',
    NONE: 'NONE',
    }
}

export default {
    name: 'IssueCertificate',
    components: {
        KakaoPreview,
        SearchClientModal,
        FormLabel,
        ConfirmModal,
    },
    data() {
        return {
            step: 1,
            deptType: MedicalDept.DENT,
            templateList: [],
            extraTemplateList: [],
            readonly,
            modals: {
                searchClientModal: {
                    show: false,
                },
                confirmModal: {
                    show: false,
                },
            },
            formRef: null,
            scrollToFirstRule: {
                behavior: 'smooth',
                block: 'center'
            },
            certificateRules: {
                hospitalName: [
                    {
                        required: true,
                        validator: this.validateHospitalName,
                        trigger: 'click',
                    },
                ],
                customerName: [
                    {
                        required: true,
                        validator: this.validateCustomerName,
                        trigger: 'click',
                    },
                ],
                customerMobile: [
                    {
                        required: true,
                        validator: this.validateCustomerMobile,
                        trigger: 'click',
                    },
                ],
                surgeryAt: [
                    {
                        required: true,
                        validator: this.validateSurgeryAt,
                        trigger: 'click',
                    },
                ],
                surgeryEndAt: [
                    {
                        required: true,
                        validator: this.validateSurgeryEndAt,
                        trigger: 'click',
                    },
                ],
            },
            templateRules: {
                selectedTemplate: [
                    {
                        required: true,
                        validator: this.validateSelectedTemplate,
                        trigger: 'click',
                    },
                ],
                selectedExtraTemplate: [
                    {
                        required: true,
                        validator: this.validateSelectedExtraTemplate,
                        trigger: 'click',
                    },
                ],
                sendPeriod: [
                    {
                        required: true,
                        validator: this.validateSendPeriod,
                        trigger: 'click',
                    },
                ],
            },
            originalFormData: {},
            clickedCancel: false,
            sendWechat: false,
            companyName: '',
            companyId: '',
            hospitalMetadata: [],
            certificateFormData: {
                hospitalName: '',
                hospitalId: '',
                customerName: '',
                customerMobile: '010',
                customerBirth: null,
                surgeryAt: dayjs(),
                surgeryEndAt:  dayjs().add(300, 'day'),
                customerId: '',
                customerGender: '',
            },
            templateFormData: {
                title: '',
                selectedTemplate: undefined,
                selectedExtraTemplate: undefined,
                templateText: '',
                extraTemplateText: '',
                sendPeriod: {
                    //기본값: https://certilife.agit.io/g/300409238/wall/347680935#comment_panel_347693546

                    type: readonly.sendPeriod.REGULAR, // SINGLE || REGULAR
                    deliveryDays: [],
                    defaultValue: {
                        afterDeliveryCount: 3,
                        afterDeliveryDay: 10,
                    },
                    startDate: dayjs(),
                },
                afterSurgeryText: `성공적인 교정 효과를 위한 clara AI 투명교정장치 사용방법

·  성인 기준 하루 16~18시간 이상 착용해주세요.
·  식사 및 양치할 때를 제외하고 장치를 항상 착용해주세요.
·  물 이외의 음료나 음식물을 섭취할 시 반드시 장치를 빼주세요.
·  장치를 착용하고 껌을 씹듯이 가볍게 저작 운동을 해주시면 좋습니다.
·  장치 재착용 후 가능하면 3시간 동안 빼지 않고 유지하는 것이 좋습니다.
·  장치 당 10일(또는 의료진의 권고일)간 착용해주세요.
·  새로운 장치는 취침 전에 교체하는 것이 가장 좋습니다.
·  clara APP을 적극적으로 활용해주세요.

< 주의사항 >

·  착용 전 장치의 변형이나 파손이 있는지 확인해주세요.
·  일반 교정 치료와 마찬가지로 질기거나 딱딱한 음식은 피해야 합니다.
    (예. 마른 오징어, 질긴 고기, 딱딱한 과일, 채소 및 견과류, 캐러멜, 엿 등)
·  장치 착용 중에 설탕이 함유된 음료수를 마실 경우 치아의 착색이나 충치를 유발할 수 있습니다.
·  뜨거운 물(40℃ 이상)은 장치에 변형을 일으킬 수 있으니 물을 마시거나 장치 세척 시 유의해주세요.
·  반려동물에 의해 장치가 손상되지 않도록 주의해주세요.
·  잇몸이 눌려서 아플 때는 빠른 시간 내에 병원에 연락하여 방문해주세요.
·  장치를 처음 착용하셨을 때는 하루에서 일주일 정도 치아가 조이는 느낌이 있을 수 있습니다.
    단, 심한 통증 시에는 착용하지 마시고 병원에 연락해주세요.
·  장치 분실 또는 변형 시 이전 장치 혹은 다음 장치를 착용하고 즉시 병원으로 연락하여 방문해주세요.
·  오랜 기간 착용하지 못해서 현재 장치가 맞지 않을 경우 무리하게 착용하지 말고 이전 장치를 착용하고
    병원에 연락하여 방문해주세요.
·  만일의 경우를 대비하여 이전 장치를 바로 버리지 말고 보관하는 것이 좋습니다.
·  하루에 1회 이상 치실을 사용하여 치아 사이에 음식물이 남아있지 않게 관리합니다.`,
            },
            locale,
            phoneNumberFormatter,
            apiHandler: this.api(),
            isButtonClicked: false,
            didValidateOnce: false,
            dept: 'DENT',
            surgeryType: 'BRACE'
        };
    },
    computed: {
        computedTemplateTitle() {
            const targetTemplate = this.templateList.find(item => item.id === this.templateFormData.selectedTemplate);
            if(!targetTemplate) return '';
            if(!targetTemplate.title) return '';
            return targetTemplate.title;
        },
        computedExtraTemplateTitle() {
            const targetTemplate = this.extraTemplateList.find(item => item.id === this.templateFormData.selectedExtraTemplate);
            if(!targetTemplate) return '';
            if(!targetTemplate.title) return '';
            return targetTemplate.title;
        },
        computedTemplateContent() {
            return this.templateFormData.templateText.replace('#{customerName}', '클라라');
        },
        computedFirstAlimtalkDate() {
            const startDate = dayjs(this.templateFormData.sendPeriod.startDate);
            if (!this.templateFormData.sendPeriod.deliveryDays || 
                this.templateFormData.sendPeriod.deliveryDays.length === 0) {
                return `${startDate.format('M')}월 ${startDate.format('D')}일 오전 9시`;
            }

            const firstDeliveryDays = this.templateFormData.sendPeriod.deliveryDays[0].afterDeliveryDay;
            const alertDate = startDate.add(firstDeliveryDays, 'day');
            
            return `${alertDate.format('M')}월 ${alertDate.format('D')}일 오전 9시`;
        },
        showFirstAlimtalkDate() {
            if(!this.templateFormData.sendPeriod.startDate) return false;
            return this.templateFormData.sendPeriod.deliveryDays?.length > 0;
        }
    },
    async mounted() {
        await this.setCompanyInfo();
        await this.getTemplates();
        await this.setTemplates();
        this.$nextTick(() => {
            if(this.$refs['mobileInput']) this.$refs['mobileInput'].focus();
        })
    },
    methods: {
        async goToStep(step) {
            if (!this.certificateFormData.hospitalName) {
                try {
                    await this.$refs.certificateFormRef.validateFields(['hospitalName']);
                } catch (validationError) {
                }
            }

            if (!this.certificateFormData.customerMobile) {
                try {
                await this.$refs.certificateFormRef.validateFields(['customerMobile']);
                } catch (validationError) {
                }
            }

            if (!this.certificateFormData.customerName) {
                try {
                await this.$refs.certificateFormRef.validateFields(['customerName']);
                } catch (validationError) {
                }
            }


            if (!this.certificateFormData.surgeryAt) {
                try {
                    await this.$refs.certificateFormRef.validateFields(['surgeryAt']);
                } catch (validationError) {
                }
            }

            if (!this.certificateFormData.surgeryEndAt) {
                try {
                    await this.$refs.certificateFormRef.validateFields(['surgeryEndAt']);
                } catch (validationError) {
                }
            }

            if (!this.templateFormData.sendPeriod) {
                try {
                    this.$refs.certificateFormRef.validateFields(['sendPeriod']);
                } catch (validationError) {
                }
            }

            this.$refs.certificateFormRef.validate().then(() => {
                this.$refs.templateFormRef.validate().then(() => {
                    this.submitTemplateData();
                    this.step = step;
                }).catch(error => {
                    console.error('error', error)
                })
            }).catch(error => {
                console.error('error', error)
            })
        },
        async setCompanyInfo() {
            const company = JSON.parse(getProfile('CompanyInfo'));
            const companyId = jwtDecoder(getAccessToken());
            if(company.name) {
                this.companyName = company.name;
            } 
            if(companyId) {
                this.companyId = companyId;
            }
        },
        async submitCertificateData() {
            if (!this.certificateFormData.hospitalName) {
                try {
                    await this.$refs.certificateFormRef.validateFields(['hospitalName']);
                } catch (validationError) {
                }
            }

            if (!this.certificateFormData.customerMobile) {
                try {
                await this.$refs.certificateFormRef.validateFields(['customerMobile']);
                } catch (validationError) {
                }
            }

            if (!this.certificateFormData.customerName) {
                try {
                await this.$refs.certificateFormRef.validateFields(['customerName']);
                } catch (validationError) {
                }
            }

            if (!this.certificateFormData.surgeryAt) {
                try {
                    await this.$refs.certificateFormRef.validateFields(['surgeryAt']);
                } catch (validationError) {
                }
            }

            if (!this.certificateFormData.surgeryEndAt) {
                try {
                    await this.$refs.certificateFormRef.validateFields(['surgeryEndAt']);
                } catch (validationError) {
                }
            }


            this.$refs.certificateFormRef2.validate().then(async () => {
                this.didValidateOnce = true;
                this.modalHandler('confirmModal', true);
            }).catch(error => {
                console.error('error', error)
            })

        },
        addPeriod() {
            this.templateFormData.sendPeriod.deliveryDays.push({
                afterDeliveryCount: this.templateFormData.sendPeriod.defaultValue.afterDeliveryCount,
                afterDeliveryDay: this.templateFormData.sendPeriod.defaultValue.afterDeliveryDay,
            });
        },
        deletePeriod(index) {
            this.templateFormData.sendPeriod.deliveryDays.splice(index, 1);
        },
        handleSendPeriod(e) {
            if(this.originalFormData.sendPeriod.type === readonly.sendPeriod.SINGLE) {
                if(e.target.value === readonly.sendPeriod.REGULAR) {
                    if(this.templateFormData.sendPeriod.deliveryDays.length === 0) {
                        this.templateFormData.sendPeriod.deliveryDays.push({
                            afterDeliveryCount: this.templateFormData.sendPeriod.defaultValue.afterDeliveryCount,
                            afterDeliveryDay: this.templateFormData.sendPeriod.defaultValue.afterDeliveryDay,
                        });
                    } else {
                        this.templateFormData.sendPeriod.deliveryDays[0].afterDeliveryDay = this.templateFormData.sendPeriod.defaultValue.afterDeliveryDay;
                        this.templateFormData.sendPeriod.deliveryDays[0].afterDeliveryCount = this.templateFormData.sendPeriod.defaultValue.afterDeliveryCount;
                    }
                }
            }
        },
        async issueCertificate() {
            const obj = {};
            if(this.isButtonClicked) return;
            this.isButtonClicked = true;
            this.$store.commit('setIsLoading', true);
            this.modalHandler('confirmModal', false);
            try {
                
                if (this.sendWechat) {
                    obj.sendType = 'wechat';
                } 
                
                // 기등록 환자 여부는 customerId로 판단
                // 등록되어있으면 업데이트
                if (this.certificateFormData.customerId) {
                    const result = await this.updateCustomerInfo();

                    if(!result) {
                        this.isButtonClicked = false;
                        this.$store.commit('setIsLoading', false);
                        this.canLeavePage = true;
                        return;
                    } 
                }

                // 병원 보증사항과 치료 후 주의사항 타이틀 추가, 내용이 없으면 그냥 공백으로 
                function formatSection(title, content) {
                    return content ? `<br><br><${title}><br><br>` + content.replaceAll('\n', '<br>') : '';
                }

                const afterSurgeryTitle = '치료 후 주의사항';
                const afterSurgerySection = formatSection(afterSurgeryTitle, this.templateFormData.afterSurgeryText);

                // 내용 바인딩
                const products = [];
                products.push(this.createBraceNftObject(afterSurgerySection));
                obj.companyId = this.certificateFormData.hospitalId;
                if(this.certificateFormData.customerId) obj.customerId = this.certificateFormData.customerId;
                obj.customerName = this.certificateFormData.customerName;
                obj.customerMobile = this.certificateFormData.customerMobile;
                obj.customerGender = this.certificateFormData.customerGender;
                obj.companyId = this.certificateFormData.hospitalId;
                obj.customerBirth = this.certificateFormData.customerBirth ? dayjs(this.certificateFormData.customerBirth).format('YYYY/MM/DD') : '';
                obj.surgeryAt = dayjs(this.surgeryDate).format('YYYY/MM/DD');
                obj.issuanceMethod = IssuanceMethodEnum.CLARA_ALIMTALK_REGULARLY;
                obj.products = products;

                const response = await this.$apiInstance.post(`/nfts`, obj);
                if (response.status !== 200 && response.status !== 201) return;
                this.isButtonClicked = false;
                this.$store.commit('setIsLoading', false);
                if (response.data.message && this.sendWechat) {
                    await oneBtnHtmlDialog(
                        '확인서 발행 실패',
                        `<div style="display:flex; align-items:center;flex-direction:column; ">
                            <span>환자가 아래 QR을 스캔해서<br> 위챗 미니앱에 가입해주세요. <br/> 
                            <b style="font-size: 14px">(위챗 信徕安 Certilife 공중계정에서도 미니앱에 가입할 수 있습니다.)</b></span>
                            <img src="${qrcodeUrl}" style="margin-top:20px;width:100%;"/>
                        </div>`,
                    );
                } else {
                    await oneBtnDialog(
                        '인증서 발행 완료',
                        '발행이 완료되었습니다.',
                        true,
                    );
                }
            } catch (error) {
                console.log(error);
                this.isButtonClicked = false;
                this.$store.commit('setIsLoading', false);
                /*

                알림톡 발송 자체에서 에러나는 경우
                response.status가 400인 경우(전화번호 양식이 백엔드에 등록된 기준에 어긋남)
                에는 메시지 따로 내보냄

                */
                if(error?.response?.message?.includes('InvalidPhoneNumberException')) {
                    await oneBtnDialog(
                        '카카오톡 전송 오류',
                        '수신자의 전화번호가 유효하지 않습니다. 전화번호를 다시 한 번 확인해주세요.',
                        false,
                    );
                } else if(error?.response?.status === 400) {
                    await oneBtnDialog(
                        '휴대폰 번호 오류',
                        '휴대폰 번호를 올바르게 입력해 주세요.',
                        false,
                    );
                } else if(error?.response?.status === 408) {
                    await oneBtnDialog(
                        '인증서 발행 실패',
                        '인증서 내용 기록 중 문제가 발생하였습니다. 서티라이프 고객센터에 문의해 주세요.',
                        false,
                    );
                } else {
                    await oneBtnDialog(
                        '확인서 발행 실패',
                        '발행에 실패하였습니다.',
                        false,
                    );
                }
                error.payload = obj;
                throw error;
            }
        },
        async updateCustomerInfo() {
            try {
                const obj = {};
                obj.name = this.certificateFormData.customerName;
                obj.mobile = this.certificateFormData.customerMobile;
                if(this.certificateFormData.customerBirth) {
                    obj.birth = dayjs(this.certificateFormData.customerBirth).format('YYYY/MM/DD');
                } else {
                    obj.birth = '';
                }
                if(obj.birth.toString().toLowerCase() === 'invalid date') {
                    // 왠지 모르겠지만 파싱 오류날 때 처리
                    obj.birth = '';
                }
                obj.gender = this.certificateFormData.customerGender;
                if (this.sendWechat) {
                    obj.sendType = 'wechat';
                }
                const response = await this.apiHandler.common().updateCustomerInfo(
                    this.certificateFormData.customerId,
                    obj
                );
                if(response.status !== 200 && repsonse.status !== 201) throw new Error('wrong status');
                return true;
            } catch(error) {
                console.log(error)
                return false;
            }
        },

        createBraceNftObject(afterSurgerySection) {
            const obj = {};

            obj.group = this.companyName;
            obj.itemName = '클라라AI 투명교정'; // 수술명?
            obj.metadataInfo = {
                background_color: Constants.defaultNftInfo.defaultColorCode,
                description: '',
                group_name: this.companyName,
                image: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card/Clara.png',
                name: '클라라AI 투명교정',
            };
            const attributes = [];

            attributes.push({
                trait_type: TraitTypeEnum.COMMON.DEPT,
                value: convertMedicalDept(this.deptType)
            });
            attributes.push({
                trait_type: TraitTypeEnum.COMMON.PRODUCTTYPE,
                value: ProductTypeEnum.TRANSPARENTBRACE,
            });
            attributes.push({
                trait_type: TraitTypeEnum.COMMON.HOSPITALNAME,
                value: this.certificateFormData.hospitalName
            });
            attributes.push({
                trait_type: TraitTypeEnum.COMMON.SURGERYDATE,
                value: dayjs(this.certificateFormData.surgeryAt).format('YYYY/MM/DD'),
            });
            attributes.push({
                trait_type: TraitTypeEnum.COMMON.SURGERYAREA,
                value: '양악',
            });

            if (this.hospitalMetadata.length > 0) {
                const metadata = deepCopy(this.hospitalMetadata).map(item => {
                    return {
                        trait_type: item.key,
                        value: item.value,
                    }
                });
                attributes.push(...metadata);
            }

            attributes.push({ trait_type: TraitTypeEnum.COMMON.INFORMTEXT, value: InformTextEnum.DEFAULT });
            attributes.push({ trait_type: TraitTypeEnum.COMMON.ISSUEDBY, value: KlipCompanyNameEnum.INNODTECH });

            obj.metadataInfo.attributes = attributes;

            const custom_links = [];
            for (let i = attributes.length - 1; i >= 0; i--) {
                const item = attributes[i];
                if (typeof item.value === 'string' && this.urlValidator(item.value)) {
                    const obj = {
                        display_name: item.trait_type,
                        value: item.value
                    };
                    custom_links.push(obj);
                    attributes.splice(i, 1);
                }
            }

            if(custom_links.length > 0) {
                obj.metadataInfo.custom_links = custom_links.reverse();
            }

            obj.deliveryOptions = {
                baseAt: this.templateFormData.sendPeriod.startDate.format('YYYY/MM/DD'),
                afterDeliveryInfo: deepCopy(this.templateFormData.sendPeriod.deliveryDays),
                delivery: this.templateFormData.sendPeriod.REGULAR,
                surgeryEndAt: this.certificateFormData.surgeryEndAt.format('YYYY/MM/DD'),
            }


            const surgeryArea = {};
            surgeryArea.dept = this.deptType;
            surgeryArea.value = '양악';
            surgeryArea.productType = '투명교정';
            obj.surgeryArea = surgeryArea;

            if (!obj.metadataInfo.description) {
                obj.metadataInfo.description = (afterSurgerySection || '');
            } else {
                obj.metadataInfo.description += (afterSurgerySection || '');
                obj.metadataInfo.description.replace('undefined', '');
            }

            return obj;
        },
        urlValidator(url) {
            if(!url) return false;
            if(typeof url !== 'string') return false;
            if(url.startsWith('http://') || url.startsWith('https://')) return true;
            return false;
        },
        async handleCustomerMobile(event) {
            this.certificateFormData.customerMobile = phoneNumberFormatter(event.target.value);
            if(this.certificateFormData.customerMobile.length < 12) return;
            await this.getCustomerInfo();
        },
        async getCustomerInfo() {
            try {
                const response = await this.apiHandler.common().getCustomerInfoByPhoneNumber(this.certificateFormData.customerMobile);
                if(response.status !== 200 && response.status !== 201) throw new Error('wrong status');

                this.certificateFormData.customerId = response.data._id;
                if(response.data.name) {
                    this.certificateFormData.customerName = response.data.name;
                } 
                if(response.data.birth) {
                    this.certificateFormData.customerBirth = dayjs(response.data.birth);
                } else {
                    this.certificateFormData.customerBirth = '';
                }
                if(response.data.gender) {
                    this.certificateFormData.customerGender = response.data.gender;
                } else {
                    this.certificateFormData.customerGender = '';
                }
                if(response.data.isBrace) {
                    const result = await twoBtnDialog('알림', `진행중인 투명교정이 있습니다. \n 교체 알림을 설정하시겠어요?`);
                    if(!result) return;
                    this.$router.push({
                        name: RouterEnum.CustomerDetails.name,
                        query: {
                            customerId: response.data._id
                        }
                    })
                }
            } catch(error) {
                console.log(error);
                this.certificateFormData.customerId = '';
                this.certificateFormData.customerName = '';
                this.certificateFormData.customerGender = '';
                this.certificateFormData.birth = null;
                this.certificateFormData.customerGender = '';

                if (error.response && error.response.status !== 404) {
                    await oneBtnDialog('환자정보 불러오기 실패', '환자정보 불러오기에 실패하였습니다.', false);
                }
            }
        },
        handleTemplateFormData(type, value) {
            if(type === 'startDate') {
                this.templateFormData.sendPeriod.startDate = value;
            } else {
                this.templateFormData[type] = value;
            }

            if (type === 'surgeryAt') {
                if(value) this.certificateFormData.surgeryEndAt = dayjs(value).add(300, 'day');
            }
        },
        openClientModal() {
            this.modalHandler('searchClientModal', true);
        },
        receiveInfoFromClientModal(data) {
            this.certificateFormData.hospitalId = data._id;
            this.certificateFormData.hospitalName = data.name;
            if(this.certificateFormData.hospitalId){
                this.setDefaultSendPeriod();
                this.getHospitalMetadata();
            }
        },
        async getHospitalMetadata() {
            const response = await this.apiHandler.common().getHospitalMetadataByCompanyId(this.certificateFormData.hospitalId);
            if(response.status !== 200 && response.status !== 201) throw new Error('status Error');
            if(response.data && response.data.attributes) {
                this.hospitalMetadata = response.data.attributes;
            }
        },
        async setDefaultSendPeriod() {
            try {
                const response = await this.$apiInstance.get(`/companies/info/${this.certificateFormData.hospitalId}`);
                if(response.status !== 200 && response.status !== 201) throw new Error('status Error');
                const { settingBizmsg } = response.data;
                if(!settingBizmsg) return;
                this.templateFormData.sendPeriod.defaultValue = {
                    afterDeliveryCount: 3,
                    afterDeliveryDay: 10,
                };

                if(this.templateFormData.sendPeriod.deliveryDays.length === 1) {
                    this.templateFormData.sendPeriod.deliveryDays[0] = {
                        afterDeliveryCount: 3,
                        afterDeliveryDay: 10,
                    };
                }
                console.log('settingBizmsg', settingBizmsg);
            } catch(error) {
                console.log(error);
            }
        },
        modalHandler(modalType, action) {
            this.modals[modalType].show = action;
        },
        async getTemplates() {
            try {
                const response = await this.$apiInstance.get(`/messages/get/bizmsg`);
                if(response.status !== 200 && response.status !== 201) throw new Error('status Error');

                if(!response.data.settingBizmsg) throw new Error('no settingBisMsg object');

                return response;
            } catch (error) {
                console.log(error);
                await oneBtnDialog('인증서 로드 실패' ,'인증서 내용 로드에 실패하였습니다.' , false);
            }
        },
        async getAfterSurgery() {
            try {
                const originalAfterSurgeryText = this.templateFormData.afterSurgeryText;
                const response = await this.$apiInstance.get(`/companies/warranty/template/${this.deptType}/${this.surgeryType}`);
                if(response.status !== 200 && response.status !== 201) throw new Error('status Error');
                this.templateFormData.afterSurgeryText = response.data.afterSurgeries?.[0]?.contents || originalAfterSurgeryText;
            } catch (error) {
                console.log(error);
                await oneBtnDialog('인증서 로드 실패' ,'인증서 내용 로드에 실패하였습니다.' , false);
            }
        },
        async setTemplates() {
            const response = await this.getTemplates();
            await this.getAfterSurgery();

            const { settingBizmsg } = response.data;
            const template = {
                id: '',
                title: '',
                content: '',
            };
            const extraTemplate = {
                id: '',
                title: '',
                content: '',
            };

            template.id = settingBizmsg.bizMsgCode;
            template.title = settingBizmsg.bizMsgName;
            template.content = settingBizmsg.bizMsgText;

            extraTemplate.id = settingBizmsg.exclusiveBizMsgCode;
            extraTemplate.title = settingBizmsg.exclusiveBizMsgName;
            extraTemplate.content = settingBizmsg.exclusiveBizMsgText;

            this.templateFormData.sendPeriod.defaultValue = {
                afterDeliveryCount: 3,
                afterDeliveryDay: 10,
            };
            this.templateFormData.sendPeriod.deliveryDays.push({
                afterDeliveryCount: 3,
                afterDeliveryDay: 10,
            })

            this.templateList.push(template);
            this.extraTemplateList.push(extraTemplate);
            this.templateFormData.selectedTemplate = this.templateList[0].id;
            this.templateFormData.selectedExtraTemplate = this.extraTemplateList[0].id;
            this.templateFormData.title = settingBizmsg.name;
            this.templateFormData.templateText = settingBizmsg.bizMsgText;
            this.templateFormData.extraTemplateText = settingBizmsg.exclusiveBizMsgText;
            this.templateFormData.sendPeriod.type = settingBizmsg.delivery;
            this.originalFormData = deepCopy(this.templateFormData);
        },
        validateSelectedTemplate(_rule, value) {
            if(this.clickedCancel) return Promise.resolve();
            if (!this.computedTemplateTitle) {
                return Promise.reject('인증서를 선택해 주세요.');
            } else {
                return Promise.resolve();
            }
        },
        validateSelectedExtraTemplate(_rule, value) {
            if(this.clickedCancel) return Promise.resolve();
            if (!this.computedExtraTemplateTitle) {
                return Promise.reject('전용 알림톡을 선택해 주세요.');
            } else {
                return Promise.resolve();
            }
        },
        validateHospitalName(_rule, value) {
            if (!this.certificateFormData.hospitalName) {
                return Promise.reject('환자가 내원한 병원을 선택해 주세요.');
            } else {
                return Promise.resolve();
            }
        },
        validateCustomerName(_rule, value) {
            if (!this.certificateFormData.customerName) {
                return Promise.reject('환자 이름을 입력해 주세요.');
            } else {
                return Promise.resolve();
            }
        },
        validateCustomerMobile(_rule, value) {
            if (!this.validateMobileNumber(this.certificateFormData.customerMobile)) {
                return Promise.reject('환자의 휴대전화 번호를 올바르게 입력해 주세요.');
            } else {
                return Promise.resolve();
            }
        },
        validateMobileNumber(input) {
            if (!input) return false;
            if (!input.startsWith('01') || input.length < 12) {
                return false;
            }
            if (input.startsWith('010-0') || input.startsWith('010-1')) {
                return false;
            }
            if (input.startsWith('01') && !input.startsWith('010') && input.length < 12) {
                return false;
            }
            if (input.startsWith('010') && input.length < 13) {
                return false;
            }
            return true;
        },
        validateSurgeryAt(_rule, value) {
            if (!this.certificateFormData.surgeryAt) {
                return Promise.reject('교정 시작일을 선택해 주세요.');
            } else {
                return Promise.resolve();
            }
        },
        validateSurgeryEndAt(_rule, value) {
            if (!this.certificateFormData.surgeryEndAt) {
                return Promise.reject('교정 예상 종료일을 선택해 주세요.');
            } else if(new Date(this.certificateFormData.surgeryEndAt) < new Date(this.certificateFormData.surgeryAt)) {
                return Promise.reject('교정 예상 종료일은 교정 시작일보다 과거일 수 없습니다.');
            } else {
                return Promise.resolve();
            }
        },
        async validateSendPeriod(_rule, value) {
            if (!this.templateFormData.sendPeriod.startDate) {
                return Promise.reject('교체 시작일을 선택해 주세요.');
            } else if (this.templateFormData.sendPeriod.deliveryDays.length === 0) {
                return Promise.reject('교체 주기를 하나 이상 선택해 주세요.');
            } else if (dayjs(this.templateFormData.sendPeriod.startDate).startOf('day').isBefore(dayjs().startOf('day'))) {
                return Promise.reject('교체 시작일을 오늘 또는 오늘 이후로 선택해 주세요.');
            } else {
                return Promise.resolve();
            }
        },
        async submitTemplateData() {           
            const obj = this.formatObject();
            try {
                const response = await this.$apiInstance.post(`/messages/set/bizmsg`, obj);
                if(response.status !== 200 && response.status !== 201) throw new Error('status Error');
            } catch (error) {
                console.log(error);
            }
        },
        formatObject() {
            const { type } = this.templateFormData.sendPeriod;

            const obj = {};
            obj.delivery = type;
            obj.name = this.templateFormData.title;
            obj.bizMsgCode = this.templateFormData.selectedTemplate;
            obj.bizMsgName = this.computedTemplateTitle;
            obj.bizMsgText = this.templateFormData.templateText;
            obj.exclusiveBizMsgCode = this.templateFormData.selectedExtraTemplate;
            obj.exclusiveBizMsgName = this.computedExtraTemplateTitle;
            obj.exclusiveBizMsgText = this.templateFormData.extraTemplateText;

            let periodData = {
                afterDeliveryDay: this.templateFormData.sendPeriod.defaultValue.afterDeliveryDay,
                afterDeliveryCount: this.templateFormData.sendPeriod.defaultValue.afterDeliveryCount,
            }
            if(this.templateFormData.sendPeriod.deliveryDays.length > 0) {
                periodData = this.templateFormData.sendPeriod.deliveryDays[0];
            }
            switch(type) {
                case readonly.sendPeriod.SINGLE:
                    obj.afterDeliveryDay = periodData.afterDeliveryDay;
                    return obj;
                case readonly.sendPeriod.REGULAR:
                    obj.afterDeliveryDay = periodData.afterDeliveryDay;
                    obj.afterDeliveryCount = periodData.afterDeliveryCount;
                    return obj;
                default:
                    return obj;
            }
        },
        formatNumber(e, type) {
            // 입력된 값이 '00'이면 '0'으로 설정
            if (e.target.value === '0') {
                e.target.value = '1';
                this.templateFormData.sendPeriod[type] = 1;
            }

            if (e.target.value === '00') {
                e.target.value = '1';
                this.templateFormData.sendPeriod[type] = 1;
            }
            
            // 숫자가 아닌 값 제거
            if (isNaN(e.target.value)) e.target.value = e.target.value.replace(/[^0-9]/g, '');

            // 숫자 값이 9999를 넘지 않도록 제한
            let numericValue = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 1;

            if (numericValue > 9999) {
                numericValue = 9999;
            }

            // 값이 10000 미만인 경우에만 설정
            if (numericValue < 10000) {
                this.templateFormData.sendPeriod[type] = numericValue;
                e.target.value = numericValue.toString();
            }
        },
        handleNumberInInput(event, dataType, index) {
            switch(event.key) {
                case 'ArrowUp':
                    this.handleNumberByClick('+', dataType, index);
                    break;
                case 'ArrowDown':
                    this.handleNumberByClick('-', dataType, index);
                    break;
                default:
                    break;
            }
        },
        handleNumberByClick(type, dataType, index) {
            if (type === '-') {
                if (this.templateFormData.sendPeriod.deliveryDays[index][dataType] === 1) return;
                this.templateFormData.sendPeriod.deliveryDays[index][dataType] --;
            } else {
                if (this.templateFormData.sendPeriod.deliveryDays[index][dataType] >= 9999) return;
                this.templateFormData.sendPeriod.deliveryDays[index][dataType] ++;
            }
        },
        async getItems() {
            try {
                const response = await ItemRequest.getItems(this.searchFilter);
                if (response.status !== 200 && response.status !== 201) throw new Error('status is not 200 or 201');
                return response.data.docs;
            } catch (error) {
                console.log(error);
                return [];
            }
        },
        api() {
            return {
                common: () => {
                    return issueCertificateCommonApis(this.$apiInstance, this.$store);
                },
            };
        },
    },
};
</script>
<style lang="scss" scoped>
    @import '@/assets/scss/issue-certificate.scss';
</style>
<style>
.ant-form-item-explain-success {
    color: red;
}
</style>
